import React from 'react';
import classNames from 'classnames';
import CustomizationRoomsItem from './CustomizationRoomsItem';

const CustomizationRooms = React.forwardRef(function CustomizationRooms(
  { rooms, setCustomStep, customState, callbacks },
  ref,
) {
  return (
    <div className={classNames(`customization__filters customization__rooms_${customState}`)}>
      {rooms.map((el, i) => (
        <CustomizationRoomsItem key={`b-${i}`} {...el} setCustomStep={setCustomStep} callbacks={callbacks} index={i} />
      ))}
    </div>
  );
});
export default CustomizationRooms;
CustomizationRooms.propTypes = {};
